import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AuthService } from "../../../auth/service/auth.service";
import url from 'src/settings.json';
import { Setting } from "../../../common/settings";
import { Organisation } from "../organisations";

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {
  setting: Setting = url;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      //Authorization: 'my-auth-token'
    }),
    params: new HttpParams()
  };
  constructor(private readonly httpClient: HttpClient,
    private readonly oAuthService: AuthService) {

  }
  public organisationEmitter = new BehaviorSubject<string>('');

  public getOrganisationEmitter() {
    return this.organisationEmitter.asObservable();
  }


  public GetOrganisations() {
    const url = `${this.setting.url}/GSC-ITSO-ADSCollection8`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<Organisation[]>(`${url}/api/organizations`, { headers: headers })
  }

  public getLocalStorageItem(key: string) {
    return localStorage.getItem(key);
  }

  public setLocalStorageItem(key: string, value: string) {
    window.localStorage.setItem(key, value);
  }
}
